export enum LifestageType {
  Baby = 'baby',
  Kitten = 'kitten',
  Puppy = 'puppy',
  Adult = 'adult',
  Mature = 'mature',
  Senior = 'ageing',
  AdvancedAgeing = 'advanced ageing',
  Junior = 'junior',
  All = 'All',
  NotAvailable = 'not_available',
}
